const fiscalyear = [
  { display_name: "January", value: "0" },
  { display_name: "February", value: "1" },
  { display_name: "March", value: "2" },
  { display_name: "April", value: "3" },
  { display_name: "May", value: "4" },
  { display_name: "June", value: "5" },
  { display_name: "July", value: "6" },
  { display_name: "August", value: "7" },
  { display_name: "September", value: "8" },
  { display_name: "October", value: "9" },
  { display_name: "November", value: "10" },
  { display_name: "December", value: "11" },
];
const states = [
  {
    display_name: "Alabama",
    value: "AL",
  },
  {
    display_name: "Alaska",
    value: "AK",
  },
  {
    display_name: "American Samoa",
    value: "AS",
  },
  {
    display_name: "Arizona",
    value: "AZ",
  },
  {
    display_name: "Arkansas",
    value: "AR",
  },
  {
    display_name: "California",
    value: "CA",
  },
  {
    display_name: "Colorado",
    value: "CO",
  },
  {
    display_name: "Connecticut",
    value: "CT",
  },
  {
    display_name: "Delaware",
    value: "DE",
  },
  {
    display_name: "District Of Columbia",
    value: "DC",
  },
  {
    display_name: "Federated States Of Micronesia",
    value: "FM",
  },
  {
    display_name: "Florida",
    value: "FL",
  },
  {
    display_name: "Georgia",
    value: "GA",
  },
  {
    display_name: "Guam",
    value: "GU",
  },
  {
    display_name: "Hawaii",
    value: "HI",
  },
  {
    display_name: "Idaho",
    value: "ID",
  },
  {
    display_name: "Illinois",
    value: "IL",
  },
  {
    display_name: "Indiana",
    value: "IN",
  },
  {
    display_name: "Iowa",
    value: "IA",
  },
  {
    display_name: "Kansas",
    value: "KS",
  },
  {
    display_name: "Kentucky",
    value: "KY",
  },
  {
    display_name: "Louisiana",
    value: "LA",
  },
  {
    display_name: "Maine",
    value: "ME",
  },
  {
    display_name: "Marshall Islands",
    value: "MH",
  },
  {
    display_name: "Maryland",
    value: "MD",
  },
  {
    display_name: "Massachusetts",
    value: "MA",
  },
  {
    display_name: "Michigan",
    value: "MI",
  },
  {
    display_name: "Minnesota",
    value: "MN",
  },
  {
    display_name: "Mississippi",
    value: "MS",
  },
  {
    display_name: "Missouri",
    value: "MO",
  },
  {
    display_name: "Montana",
    value: "MT",
  },
  {
    display_name: "Nebraska",
    value: "NE",
  },
  {
    display_name: "Nevada",
    value: "NV",
  },
  {
    display_name: "New Hampshire",
    value: "NH",
  },
  {
    display_name: "New Jersey",
    value: "NJ",
  },
  {
    display_name: "New Mexico",
    value: "NM",
  },
  {
    display_name: "New York",
    value: "NY",
  },
  {
    display_name: "North Carolina",
    value: "NC",
  },
  {
    display_name: "North Dakota",
    value: "ND",
  },
  {
    display_name: "Northern Mariana Islands",
    value: "MP",
  },
  {
    display_name: "Ohio",
    value: "OH",
  },
  {
    display_name: "Oklahoma",
    value: "OK",
  },
  {
    display_name: "Oregon",
    value: "OR",
  },
  {
    display_name: "Palau",
    value: "PW",
  },
  {
    display_name: "Pennsylvania",
    value: "PA",
  },
  {
    display_name: "Puerto Rico",
    value: "PR",
  },
  {
    display_name: "Rhode Island",
    value: "RI",
  },
  {
    display_name: "South Carolina",
    value: "SC",
  },
  {
    display_name: "South Dakota",
    value: "SD",
  },
  {
    display_name: "Tennessee",
    value: "TN",
  },
  {
    display_name: "Texas",
    value: "TX",
  },
  {
    display_name: "Utah",
    value: "UT",
  },
  {
    display_name: "Vermont",
    value: "VT",
  },
  {
    display_name: "Virgin Islands",
    value: "VI",
  },
  {
    display_name: "Virginia",
    value: "VA",
  },
  {
    display_name: "Washington",
    value: "WA",
  },
  {
    display_name: "West Virginia",
    value: "WV",
  },
  {
    display_name: "Wisconsin",
    value: "WI",
  },
  {
    display_name: "Wyoming",
    value: "WY",
  },
];
const accountType = [
  {
    label: "Assets",

    items: [
      { label: "Bank", key: "1" },
      { label: "Account Receivable", key: "2" },
      { label: "Current Asset", key: "3" },
      { label: "Inventory", key: "4" },
      { label: "Fixed Asset", key: "5" },
      { label: "Other Asset", key: "6" },
    ],
  },
  {
    label: "Liabilities",
    items: [
      { label: "Account Payable", key: "7" },
      { label: "Current Liability", key: "8" },
      { label: "Credit Card", key: "9" },
      { label: "Other Liability", key: "10" },
    ],
  },
  {
    items: [
      { label: "Equity", key: "11" },
      { label: "Revenue", key: "13" },
      { label: "Cost of Sale", key: "14" },
      { label: "Expense", key: "15" },
      { label: "Other Income", key: "16" },
      { label: "Other Expense", key: "17" },
    ],
  },
];
const paymentType = [
  {
    items: [
      { label: "Cash", key: 1 },
      { label: "Check", key: 2 },
      { label: "Debit Card", key: 3 },
    ],
  },
  {
    label: "Credit Card",
    items: [
      { label: "American Express", key: 7 },
      { label: "Discover", key: 8 },
      { label: "Master Card", key: 9 },
      { label: "Visa", key: 10 },
      { label: "Other Credit Card", key: 5 },
    ],
  },
  {
    label: "Other",
    items: [
      { label: "Electronic Cash", key: 11 },
      { label: "Electronic Check", key: 12 },
      { label: "Electronic Funds Transfer", key: 13 },
      { label: "Money Order", key: 14 },
      { label: "Pay Pal", key: 15 },
      { label: "Other", key: 16 },
    ],
  },
];
const tzInts = [
  { label: "(GMT-12:00) International Date Line West", value: "0" },
  { label: "(GMT-11:00) Midway Island, Samoa", value: "1" },
  { label: "(GMT-10:00) Hawaii", value: "2" },
  { label: "(GMT-09:00) Alaska", value: "3" },
  { label: "(GMT-08:00) Pacific Time (US & Canada)", value: "4" },
  { label: "(GMT-08:00) Tijuana, Baja California", value: "5" },
  { label: "(GMT-07:00) Arizona", value: "6" },
  { label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan", value: "7" },
  { label: "(GMT-07:00) Mountain Time (US & Canada)", value: "8" },
  { label: "(GMT-06:00) Central America", value: "9" },
  { label: "(GMT-06:00) Central Time (US & Canada)", value: "10" },
  { label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco", value: "11" },
  { label: "(GMT-05:00) Eastern Time (US & Canada)", value: "12" },
  { label: "(GMT-05:00) Indiana (East)", value: "13" },
  { label: "(GMT-04:00) Atlantic Time (Canada)", value: "14" },
  { label: "(GMT-04:00) Caracas, La Paz", value: "15" },
  { label: "(GMT-04:00) Manaus", value: "16" },
  { label: "(GMT-04:00) Santiago", value: "17" },
  { label: "(GMT-03:30) Newfoundland", value: "18" },
  { label: "(GMT-03:00) Brasilia", value: "19" },
  { label: "(GMT-03:00) Buenos Aires, Georgetown", value: "20" },
  { label: "(GMT-03:00) Greenland", value: "21" },
  { label: "(GMT-03:00) Montevideo", value: "22" },
  { label: "(GMT-02:00) Mid-Atlantic", value: "23" },
  { label: "(GMT-01:00) Cape Verde Is.", value: "24" },
  { label: "(GMT-01:00) Azores", value: "25" },
  { label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik", value: "26" },
  {
    label:
      "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
    value: "27",
  },
  {
    label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    value: "28",
  },
  {
    label: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    value: "29",
  },
  { label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris", value: "30" },
  { label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb", value: "31" },
  { label: "(GMT+01:00) West Central Africa", value: "32" },
  { label: "(GMT+02:00) Amman", value: "33" },
  { label: "(GMT+02:00) Athens, Bucharest, Istanbul", value: "34" },
  { label: "(GMT+02:00) Beirut", value: "35" },
  { label: "(GMT+02:00) Cairo", value: "36" },
  { label: "(GMT+02:00) Harare, Pretoria", value: "37" },
  {
    label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    value: "38",
  },
  { label: "(GMT+02:00) Jerusalem", value: "39" },
  { label: "(GMT+02:00) Minsk", value: "40" },
  { label: "(GMT+02:00) Windhoek", value: "41" },
  { label: "(GMT+03:00) Kuwait, Riyadh, Baghdad", value: "42" },
  { label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd", value: "43" },
  { label: "(GMT+03:00) Nairobi", value: "44" },
  { label: "(GMT+03:00) Tbilisi", value: "45" },
  { label: "(GMT+03:30) Tehran", value: "46" },
  { label: "(GMT+04:00) Abu Dhabi, Muscat", value: "47" },
  { label: "(GMT+04:00) Baku", value: "48" },
  { label: "(GMT+04:00) Yerevan", value: "49" },
  { label: "(GMT+04:30) Kabul", value: "50" },
  { label: "(GMT+05:00) Yekaterinburg", value: "51" },
  { label: "(GMT+05:00) Islamabad, Karachi, Tashkent", value: "52" },
  { label: "(GMT+05:30) Sri Jayawardenapura", value: "53" },
  { label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi", value: "54" },
  { label: "(GMT+05:45) Kathmandu", value: "55" },
  { label: "(GMT+06:00) Almaty, Novosibirsk", value: "56" },
  { label: "(GMT+06:00) Astana, Dhaka", value: "57" },
  { label: "(GMT+06:30) Yangon (Rangoon)", value: "58" },
  { label: "(GMT+07:00) Bangkok, Hanoi, Jakarta", value: "59" },
  { label: "(GMT+07:00) Krasnoyarsk", value: "60" },
  { label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi", value: "61" },
  { label: "(GMT+08:00) Kuala Lumpur, Singapore", value: "62" },
  { label: "(GMT+08:00) Irkutsk, Ulaan Bataar", value: "63" },
  { label: "(GMT+08:00) Perth", value: "64" },
  { label: "(GMT+08:00) Taipei", value: "65" },
  { label: "(GMT+09:00) Osaka, Sapporo, Tokyo", value: "66" },
  { label: "(GMT+09:00) Seoul", value: "67" },
  { label: "(GMT+09:00) Yakutsk", value: "68" },
  { label: "(GMT+09:30) Adelaide", value: "69" },
  { label: "(GMT+09:30) Darwin", value: "70" },
  { label: "(GMT+10:00) Brisbane", value: "71" },
  { label: "(GMT+10:00) Canberra, Melbourne, Sydney", value: "72" },
  { label: "(GMT+10:00) Hobart", value: "10" },
  { label: "(GMT+10:00) Guam, Port Moresby", value: "73" },
  { label: "(GMT+10:00) Vladivostok", value: "74" },
  { label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia", value: "75" },
  { label: "(GMT+12:00) Auckland, Wellington", value: "76" },
  { label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.", value: "77" },
  { label: "(GMT+13:00) Nuku'alofa", value: "78" },
];

const calendarColors = [
  { key: "", label: "", value: "55" },
  { key: "4169E1", label: "Royal Blue", value: "1" },
  { key: "3366CC", label: "Mariner", value: "2" },
  { key: "1959A8", label: "Fun Blue", value: "3" },
  { key: "0076A3", label: "Allports", value: "4" },
  { key: "377475", label: "Oracle", value: "5" },
  { key: "202E54", label: "Cloud Burst", value: "6" },
  { key: "003153", label: "Prussian Blue", value: "7" },
  { key: "13264D", label: "Blue Zodiac", value: "8" },
  { key: "v0E0E18", label: "Cinder", value: "9" },
  { key: "74C365", label: "Mantis", value: "10" },
  { key: "83AA5D", label: "Chelsea Cucumber", value: "11" },
  { key: "7BA05B", label: "Asparagus", value: "12" },
  { key: "7B9F80", label: "Amulet", value: "13" },
  { key: "4F9D5D", label: "Fruit Salad", value: "14" },
  { key: "228B22", label: "Forest Green", value: "15" },
  { key: "7C881A", label: "Trendy Green", value: "16" },
  { key: "368716", label: "La Palma", value: "17" },
  { key: "578363", label: "Spring Leaves", value: "18" },
  { key: "3B7A57", label: "Amazon", value: "19" },
  { key: "00581A", label: "Camarone", value: "20" },
  { key: "134F19", label: "Parsley", value: "21" },
  { key: "1B2F11", label: "Seaweed", value: "22" },
  { key: "0B1304", label: "Black Forest", value: "23" },
  { key: "AD781B", label: "Mandalay", value: "24" },
  { key: "9D5616", label: "Hawaiian Tan", value: "25" },
  { key: "782F16", label: "Peanut", value: "26" },
  { key: "683600", label: "Nutmeg Wood", value: "27" },
  { key: "55280C", label: "Cioccolato", value: "28" },
  { key: "441D00", label: "Morocco Brown", value: "29" },
  { key: "3C2005", label: "Dark Ebony", value: "30" },
  { key: "301F1E", label: "Cocoa Brown", value: "31" },
  { key: "DCB20C", label: "Galliano", value: "32" },
  { key: "ECA927", label: "Fuel Yellow", value: "33" },
  { key: "CD8429", label: "Brandy Punch", value: "34" },
  { key: "DA6304", label: "Bamboo", value: "35" },
  { key: "AA4203", label: "Fire", value: "36" },
  { key: "BA0101", label: "Guardsman Red", value: "37" },
  { key: "92000A", label: "Sangria", value: "38" },
  { key: "780109", label: "Japanese Maple", value: "39" },
  { key: "AF4D43", label: "Apple Blossom", value: "40" },
  { key: "893843", label: "Solid Pink", value: "41" },
  { key: "C32148", label: "Maroon Flush", value: "42" },
  { key: "A50B5E", label: "Jazzberry Jam", value: "43" },
  { key: "843179", label: "Plum", value: "44" },
  { key: "991199", label: "Violet Eggplant", value: "45" },
  { key: "8C055E", label: "Cardinal Pink", value: "46" },
  { key: "893456", label: "Camelot", value: "47" },
  { key: "67032D", label: "Black Rose", value: "48" },
  { key: "33036B", label: "Christalle", value: "49" },
  { key: "431560", label: "Scarlet Gum", value: "50" },
  { key: "480656", label: "Clairvoyant", value: "51" },
  { key: "410056", label: "Ripe Plum", value: "52" },
  { key: "240A40", label: "Violet", value: "53" },
  { key: "44012D", label: "Barossa", value: "54" },
  { key: "300529", label: "Melanzane", value: "55" },
  { key: "3A0020", label: "Toledo", value: "56" },
  { key: "3E3A44", label: "Ship Gray", value: "57" },
  { key: "130000", label: "Diesel", value: "58" },
];
const years = [
  { display_name: "2020", value: "1" },
  { display_name: "2014", value: "2" },
  { display_name: "2013", value: "3" },
  { display_name: "2012", value: "4" },
  { display_name: "2010", value: "5" },
  { display_name: "2009", value: "6" },
];
const months = [
  { display_name: "Jan", value: "0" },
  { display_name: "Feb", value: "1" },
  { display_name: "Mar", value: "2" },
  { display_name: "Apr", value: "3" },
  { display_name: "May", value: "4" },
  { display_name: "Jun", value: "5" },
  { display_name: "Jul", value: "6" },

  { display_name: "Aug", value: "7" },
  { display_name: "Sep", value: "8" },
  { display_name: "Oct", value: "9" },
  { display_name: "Nov", value: "10" },
  { display_name: "Dec", value: "11" },
];
const hoursMilitary = [
  { label: "0000", value: "0:00:00" },
  { label: "0100", value: "1:00:00" },
  { label: "0200", value: "2:00:00" },
  { label: "0300", value: "3:00:00" },
  { label: "0400", value: "4:00:00" },
  { label: "0500", value: "5:00:00" },
  { label: "0600", value: "6:00:00" },
  { label: "0700", value: "7:00:00" },
  { label: "0800", value: "8:00:00" },
  { label: "0900", value: "9:00:00" },
  { label: "1000", value: "10:00:00" },
  { label: "1100", value: "11:00:00" },
  { label: "1200", value: "12:00:00" },
];
const hoursCivilian = [
  { label: "12 AM", value: "0:00:00" },
  { label: "1 AM", value: "1:00:00" },
  { label: "2 AM", value: "2:00:00" },
  { label: "3 AM", value: "3:00:00" },
  { label: "4 AM", value: "4:00:00" },
  { label: "5 AM", value: "5:00:00" },
  { label: "6 AM", value: "6:00:00" },
  { label: "7 AM", value: "7:00:00" },
  { label: "8 AM", value: "8:00:00" },
  { label: "9 AM", value: "9:00:00" },
  { label: "10 AM", value: "10:00:00" },
  { label: "11 AM", value: "11:00:00" },
  { label: "12 PM", value: "12:00:00" },
];

export {
  states,
  accountType,
  tzInts,
  fiscalyear,
  calendarColors,
  years,
  months,
  hoursMilitary,
  hoursCivilian,
  paymentType,
};
